import * as Sentry from '@sentry/vue';

export default function pushToDataLayer(gtmDataObject) {
  const GTM = window.dataLayer;
  if (!GTM) return;
  try {
    GTM.push(gtmDataObject);
  } catch (error) {
    Sentry.captureException(error);
  }
}
